import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
import {WarningIcon} from 'shells/icon/svg/warning-icon';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';

import {AiButtonContent} from '../ai-button-content';

import styles from './power-ai-usage-popover.module.css';

type Props = {
    monthlyUsage:
        | {
              limit: number | null | undefined;
              remaining: number;
          }
        | null
        | undefined;
    shouldShowBillingLink: boolean;
    isTooltip: boolean;
    title: string;
    body: React.ReactNode;
    limitsContent?: React.ReactNode | null | undefined;
    linkContainerRef?: any;
    acknowledgment?: {
        onClick: () => void;
    };
    isRoutedLink?: boolean;
};

export function AiUsagePopoverContent(props: Props) {
    const {isRoutedLink = true} = props;

    const acknowledgmentButton = props.acknowledgment ? (
        <Button
            variant='text-primary'
            size='small'
            onMouseDown={props.acknowledgment.onClick}
            noPadding={true}
        >
            Got it
        </Button>
    ) : undefined;

    const billingLink =
        props.shouldShowBillingLink && !props.isTooltip ? (
            <div ref={props.linkContainerRef}>
                <Link
                    variant='button-ai-blue'
                    // @ts-expect-error
                    as={isRoutedLink ? RoutedLink : 'a'}
                    to='/setup/billing/sales'
                    href='/setup/billing/sales'
                    newTab={true}
                    isFullWidth={true}
                >
                    <div className='flex justify-center'>
                        <AiButtonContent
                            buttonText={
                                props.monthlyUsage && props.monthlyUsage.remaining <= 0
                                    ? 'Upgrade plan'
                                    : 'View plan'
                            }
                            buttonRef={props.linkContainerRef}
                        />
                    </div>
                </Link>
            </div>
        ) : undefined;

    return (
        <div className={styles['power-ai-usage-popover-content']}>
            {props.monthlyUsage && props.monthlyUsage.remaining <= 0 && (
                <div className={styles['no-credits']}>
                    {/* @ts-expect-error */}
                    <WarningIcon size={15} wrapWithDiv={false} color={colors.orange} />
                    <div>
                        {NutClientConfig.hasAiOutcomesFF ? 'No outcomes left' : 'No credits left'}
                    </div>
                </div>
            )}
            <StackLegacy spacing={12}>
                <div className={styles.title}>{props.title}</div>
                <div>{props.body}</div>
                <Divider variant='line--horizontal' />
                {props.limitsContent}
                {acknowledgmentButton && billingLink ? (
                    <div className='flex justify-sb'>
                        {acknowledgmentButton}
                        {billingLink}
                    </div>
                ) : (
                    <>{billingLink || acknowledgmentButton}</>
                )}
            </StackLegacy>
        </div>
    );
}
